import type { SupportedLocales } from '../supportedLocales';
import type { TimeFormat } from './types';

const localeAliases: Partial<Record<SupportedLocales, string>> = {
  es_LA: 'es',
  'fa-af': 'fa-AF',
  fr_FR: 'fr-FR',
  pt_br: 'pt-BR',
  pt_BR: 'pt-BR',
  'zh-tw': 'zh-TW',
};

const pluralRulesCache = new Map<string, Intl.PluralRules>();

function getPluralRules(locale: SupportedLocales): Intl.PluralRules | null {
  if (typeof Intl === 'undefined' || typeof Intl.PluralRules === 'undefined') {
    return null;
  }

  const normalizedLocale = localeAliases[locale] ?? locale.replace('_', '-');

  if (!pluralRulesCache.has(normalizedLocale)) {
    pluralRulesCache.set(normalizedLocale, new Intl.PluralRules(normalizedLocale));
  }

  return pluralRulesCache.get(normalizedLocale) ?? null;
}

export function _pluralize(value: number, format: TimeFormat, locale: SupportedLocales): string {
  const pluralRules = getPluralRules(locale);
  const pluralCategory = pluralRules?.select(value) ?? (value === 1 ? 'one' : 'other');
  if (pluralCategory === 'one') {
    return format.one;
  }

  if (pluralCategory === 'few' && format.few) {
    return format.few;
  }

  return format.other;
}
